<template>
  <div class="orders-view-wrapper">
    <orders-operator
      v-if="isOperator"
      @data-ready="restoreScroll" />
    <orders
      v-else
      @data-ready="restoreScroll" />
  </div>
</template>

<script>
import Orders from './Orders.vue';
import OrdersOperator from './OrdersOperator.vue';

export default {
  name: 'orders-wrapper',
  components: {
    'orders': Orders,
    'orders-operator': OrdersOperator,
  },
  computed: {
    isOperator () {
      return this.$store.getters['getUserType'] === 'OPERATOR';
    }
  },
  methods: {
    restoreScroll() {
      const scrollY = sessionStorage.getItem('orders-scroll-y');
      if (scrollY) {
        this.$nextTick(() => {
          window.scrollTo(0, parseInt(scrollY, 10));
          sessionStorage.removeItem('orders-scroll-y');
        });
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    let isGoingToForm = to.path.startsWith('/zamowienia/edycja/') || to.path.startsWith('/zamowienia/podglad/') || to.path.startsWith('/zamowienia/maszyny/edycja/');

    if (isGoingToForm) {
      sessionStorage.setItem('orders-scroll-y', window.scrollY);
    } else {
      sessionStorage.removeItem('orders-scroll-y');
    }

    next();
  }
};
</script>
